import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
/**
 * Merge class names with Tailwind conflict resolution.
 * Combines `classnames` (conditional class composition) with `tailwind-merge`
 * (so later Tailwind utilities win over earlier conflicting ones).
 */
export const cn = (...inputs) => twMerge(classNames(...inputs));
